package app

import Link
import RouteType
import org.jooq.ICatalog
import org.jooq.MenuType
import org.jooq.ISchema

enum class MenuPosition{TOP,LEFT;}
data class Menus(val primaryMenus:Array<Menu>, val subMenus:Array<SubMenu>, val activeMenuPath: ActiveMenuPath)
data class ActiveMenuPath(val primaryMenu: Menu, val subMenu: MenuType? = null, val subMenuItemLink: Link? = null, val extraBreadcrumb:String?=null)
data class SubMenu(val menu: MenuType, val position:MenuPosition,var items:Array<RouteType>)

enum class DefaultSubMenu(private val literal: String) : MenuType {
    我的诊室("我的诊室"),
    辩证管理("辩证管理"),
    基础管理("基础管理"),
    帮助与说明("帮助与说明"),
    经方学习("经方学习"),
    经典阅读("经典阅读"),
    学习指南("学习指南"),
    针灸学习("针灸学习"),
    经方传承("经方传承"),
    体质研究("体质研究"),
    医师资格考试("医师资格考试"),
    经方社区("经方社区"),
    中医动态("中医动态"),
    我要求医("我要求医"),
    应用设置("应用设置"),
    方药学习("方药学习"),
    ;
    override fun getCatalog(): ICatalog? {return null}
    override fun getSchema(): ISchema? {return null}
    override fun getName(): String? {return "organization_loa_health_management"}
    override fun getLiteral(): String {return literal}
}

enum class SettingsSubMenu(private val literal: String) : MenuType {
    /*机构设置("机构设置"),//下级机构，部门，合作机构
    人员管理("人员管理"),//团队管理，医生管理，角色与权限
    家庭医生签约设置("家庭医生签约设置"),
    档案设置("档案设置"), //合格检查设置("合格检查设置"),自定义内容
    健康体检设置("健康体检设置"),//合格检查设置, 健康检查项目模板 , 检查项参考值，自定义内容
    ;
     fun getCatalog(): Catalog? {return null}
     fun getSchema(): Schema? {return null}
    override fun getName(): String? {return "organization_loa_health_management"}
    override fun getLiteral(): String {return literal}*/
}

enum class Menu(val loginOnly:Boolean,val subMenus: Array<SubMenu>?,val linkTo: RouteType?=null) {
    首页(false,arrayOf(),DefaultRoute.Home),
    一起学中医(false,arrayOf(
        SubMenu(
            DefaultSubMenu.学习指南,MenuPosition.LEFT, arrayOf(
                LearningRoute.TcmFaq,
                LearningRoute.Guidelines,
                //CommunityRoute.News,
                //CommunityRoute.Moments,
                /*CommunityRoute.Notes,
                CommunityRoute.Clubs*/
            )
        ),
        SubMenu(
            DefaultSubMenu.经方学习,MenuPosition.LEFT, arrayOf(
                LearningRoute.ShanghanlunReading,
                LearningRoute.MedicalRecordList,
                /*LearningRoute.Prescriptions,
                LearningRoute.Medicines,*/
                SmartTcmRoute.SignSymptomList//StudyRoute.SignSymptoms
            )
        ),
        /*SubMenu(
            DefaultSubMenu.经典阅读,MenuPosition.LEFT, arrayOf(
                StudyRoute.Books,
                StudyRoute.Notes,
                StudyRoute.Recite
                )
        ),*/
        SubMenu(
            DefaultSubMenu.方药学习,MenuPosition.LEFT, arrayOf(
                SmartTcmRoute.MedicineList,
                LearningRoute.PrescriptionList
            )
        ),
        SubMenu(
            DefaultSubMenu.针灸学习,MenuPosition.LEFT, arrayOf(
                LearningRoute.Meridians,
                LearningRoute.AcupointList
                /*StudyRoute.Notes,
                StudyRoute.Recite*/
            )
        ),


        /*SubMenu(
            DefaultSubMenu.经方传承,MenuPosition.LEFT, arrayOf(
                StudyRoute.Education,
                StudyRoute.ClassRoom,
                InheritanceRoute.Master,//经方大家
                InheritanceRoute.Inheritance, //传承教育
            )
        ),
        SubMenu(
            DefaultSubMenu.体质研究,MenuPosition.LEFT, arrayOf(
                StudyRoute.ConstitutionalClassification
            )
        ),
        SubMenu(
            DefaultSubMenu.医师资格考试,MenuPosition.LEFT, arrayOf(
                StudyRoute.QualificationTest,
                StudyRoute.SpecialistsGuide
            )
        )*/
    ),LearningRoute.ShanghanlunReading),
    /*经方社区(arrayOf(
        SubMenu(
            DefaultSubMenu.经方社区,MenuPosition.LEFT, arrayOf(
                CommunityRoute.Topics,
                CommunityRoute.News,*/
                //CommunityRoute.Moments,
                /*CommunityRoute.Notes,
                CommunityRoute.Clubs*/
   //     )
   // ),),CommunityRoute.Topics),
    /*我要求医(arrayOf(
        SubMenu(
            DefaultSubMenu.我要求医,MenuPosition.LEFT, arrayOf(
                SeeDoctorRoute.Organizations,
                SeeDoctorRoute.Doctors,
                SeeDoctorRoute.SeeDoctor,
                SeeDoctorRoute.SelfDiagnosis,
                SeeDoctorRoute.ConstitutionalClassification
            )
        )
    ),SeeDoctorRoute.Organizations),*/
    /*中医动态(arrayOf(
        SubMenu(
            DefaultSubMenu.中医动态,MenuPosition.LEFT, arrayOf(
                NewsRoute.News,
                NewsRoute.Policy
            )
        )
    ),NewsRoute.News),*/
    //支持贡献(arrayOf(),DefaultRoute.Contribution),
    /*关于我们(arrayOf(),DefaultRoute.AboutUs)*/
    诊疗中心(true,arrayOf(
        SubMenu(
            DefaultSubMenu.我的诊室, MenuPosition.LEFT,arrayOf(
                //SmartTcmRoute.Index,
                SmartTcmRoute.WaitingArea,
                //SmartTcmRoute.PatientList,
                //SmartTcmRoute.MedicalRecordList,
                //SmartTcmRoute.Practice
            )
        ),
        /*SubMenu(
            DefaultSubMenu.辩证管理, MenuPosition.LEFT,arrayOf(
                SmartTcmRoute.SyndromeList,
                SmartTcmRoute.DifferentiationPrescriptionList,
                SmartTcmRoute.DifferentiationRuleList,
                //SmartTcmRoute.PrivateMedicalRecordList
            )
        ),*/
        /*SubMenu(
            DefaultSubMenu.基础管理, MenuPosition.LEFT,arrayOf(
                SmartTcmRoute.SignSymptomList,
                SmartTcmRoute.PrescriptionList,
                SmartTcmRoute.MedicineList,
                SmartTcmRoute.MedicineStorage
            )
        ),
        SubMenu(DefaultSubMenu.帮助与说明,MenuPosition.LEFT, arrayOf(
            SmartTcmRoute.Help,
            SmartTcmRoute.Introduction,
        ))*/
    ),SmartTcmRoute.WaitingArea),
    设置(true,arrayOf(
        SubMenu(
            DefaultSubMenu.应用设置,MenuPosition.LEFT, arrayOf(
                SettingRoute.MedicineSetting,
                SettingRoute.PrescriptionSetting,
                SettingRoute.DiagnosisSetting,
                SettingRoute.SyndromeSetting,
                //SettingRoute.SyndromePrescriptionSetting,
                //SettingRoute.DifferentiationRuleSetting
            )
        )
    ),SettingRoute.SyndromeSetting);

    companion object{
        /**
         * 获取可访问的次级菜单项
         */
        fun getAccessableSubMenuItems(menu: Menu):Array<SubMenu>{
            console.log("start getAccessableSubMenuItems",menu);
            var accessableSubMenus = arrayOf<SubMenu>()
            menu.subMenus?.let{
                accessableSubMenus = it
            }
           // var configuredOrganizationMenus = arrayOf<MenuType>()
           // val memberData = AuthService.getMemberData()
            /*if(memberData != null && memberData.organizationMenu != null){
                memberData!!.organizationMenu!!.healthManagement?.forEach {
                    configuredOrganizationMenus += it
                }
                memberData!!.organizationMenu!!.app?.forEach {
                    configuredOrganizationMenus += it
                }
                memberData!!.organizationMenu!!.settings?.forEach {
                    configuredOrganizationMenus += it
                }
                memberData!!.organizationMenu!!.dignosisTreatment?.forEach {
                    configuredOrganizationMenus += it
                }
                memberData!!.organizationMenu!!.diseaseControl?.forEach {
                    configuredOrganizationMenus += it
                }
                memberData!!.organizationMenu!!.workManagement?.forEach {
                    configuredOrganizationMenus += it
                }
                menu.subMenus?.forEach { subMenu->
                    if(menu == 首页){ //首页暂时不可配置权限
                        accessableSubMenus += subMenu
                    }else if(configuredOrganizationMenus.contains(subMenu.label)){
                        subMenu.items = subMenu.items.filter { item-> PermissionChecker.canAccess(item) }.toTypedArray()
                        if(!subMenu.items.isEmpty()){
                            accessableSubMenus += subMenu
                        }
                    }
                }
            }*/
            console.log("end of getAccessableSubMenuItems",accessableSubMenus);
            return accessableSubMenus
        }
    }

}
